export const ANTAQ_PORTOS_ZIP_URL =
  'https://www.gov.br/antaq/pt-br/central-de-conteudos/Instalaesporturias06052025.zip';

export const PORTOS_GOLDEN_SANTOS = 'BRSSZ';

export const PORTOS_MIN_COUNT = 800;

export const PORTOS_MAX_COUNT = 1500;
